import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=79b399e2&scoped=true&"
var script = {}
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=79b399e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b399e2",
  null
  
)

export default component.exports